<div class="widgets">
  <div class="title" (click)="goToPortefeuille()">
    <span class="title_left">
      <i class="fa fa-star-o" aria-hidden="true"></i>
      {{ 'HOME.SITES_FAVORIS.TITLE' | translate }}
    </span>
  </div>

  <div class="content">
    @if (state() === allStates.LOADING) {
      <div class="loading-content center">
        <ion-icon name="sync" class="infinite-rotate"></ion-icon>
        <span>{{ 'GLOBAL.LOADING' | translate }}</span>
      </div>
    } @else {
      @if (state() === allStates.ERROR) {
        <div class="loading-content center">
          <span>{{ 'HOME.SITES_FAVORIS.ERROR' | translate }}</span>
        </div>
      } @else {
        @if (sitesFavoris.length > 0) {
          <div class="sites_list">
            <ion-item *ngFor="let site of sitesFavorisToDisplay" class="site" (click)="showDetail(site)">
              <ion-label>{{ site.libelle_long }}</ion-label>
              <ion-icon slot="end" name="chevron-forward-outline" color="gris"></ion-icon>
            </ion-item>
            @if (sitesFavoris?.length > 5) {
              <ion-button fill="clear" class="site change_display" (click)="changeDisplay()">
                {{
                  this.showAllSites
                    ? ('HOME.SITES_FAVORIS.VOIR_MOINS' | translate)
                    : ('HOME.SITES_FAVORIS.VOIR_TOUT' | translate)
                }}
              </ion-button>
            }
          </div>
        } @else {
          <div class="centered-vertical">
            <span [innerHTML]="'HOME.SITES_FAVORIS.NO_SITES' | translate">></span>
          </div>
        }
      }
    }
  </div>
</div>
